import { ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { BootstrapTooltip } from "../../../../components/Common/BootstrapTooltip";
import Zoom from "@mui/material/Zoom";
import React from "react";

interface MenuItemWrapperProps {
  itemKey: string;
  pathname: string;
  route: string;
  label: string;
  icon: React.ReactNode;
  isOpen: boolean;
  onClick: () => void;
}

export const MenuItemWrapper: React.FC<MenuItemWrapperProps> = React.memo(({
  itemKey,
  pathname,
  route,
  label,
  icon,
  isOpen,
  onClick
}) => (
  <ListItem
    key={itemKey}
    disablePadding
    className={route === pathname ? "active-master-class" : "nav-ListItemButton"}
    sx={{ display: "block" }}
    onClick={onClick}
  >
    <ListItemButton
      sx={{
        minHeight: 24,
        justifyContent: isOpen ? "initial" : "center",
        px: 0.5,
        borderRadius: "12px",
        "&:hover": {
          backgroundColor: "#e9eefa",
          color: "#3b75ff",
        },
      }}
    >
      <ListItemIcon
        className="nav-ListItemButton"
        sx={{
          minWidth: 0,
          mr: isOpen ? 3 : "auto",
          justifyContent: "center",
        }}
      >
        {isOpen ? (
          <span className="menu-icon-span">{icon}</span>
        ) : (
          <BootstrapTooltip
            TransitionComponent={Zoom}
            title={<span style={{ fontSize: "12px" }}>{label}</span>}
            placement="right"
          >
            <span className="menu-icon-span">{icon}</span>
          </BootstrapTooltip>
        )}
      </ListItemIcon>
      <ListItemText
        primary={label}
        sx={{ opacity: isOpen ? 1 : 0 }}
        className="menu-item-text"
      />
    </ListItemButton>
  </ListItem>
));

MenuItemWrapper.displayName = "MenuItemWrapper";
